import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttFormSearch, SttSelectMshipDialog } from '../all';

type Mship = {
    id: number;
    fullName: string;
};

type Props = {
    grid?: boolean;
    md?: number;
    xs?: number;
    caption?: string;
    name?: string;
    mship?: Mship | null;
    readOnly?: boolean;
    onChange?: (event: { name: string | undefined; value: unknown }) => void;
    onSelect?: (mship: Mship | null) => void;
    [key: string]: unknown;
};

/**
 *    Select a mship (user)
 *
 *    Props:
 *
 *    * function onSelect(mship)
 *    * object mship: mship data
 *    * boolean readOnly
 */
export function SttSelectMship({
    grid = true,
    md = 12,
    xs = 12,
    caption,
    mship,
    readOnly = false,
    onChange,
    onSelect,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [dialogOpened, setDialogOpened] = useState(false);

    /**
     * Click search
     */
    const handleClickSearch = () => {
        setDialogOpened(true);
    };

    useEffect(() => {
        if (!mship && onSelect) {
            onSelect({ fullName: '' } as Mship);
        }
    }, [mship, onSelect]);

    // -----| Render |-----
    const content = (
        <>
            {mship && (
                <SttFormSearch
                    disabled
                    caption={caption || t('labels.user')}
                    defVal={mship && mship.fullName}
                    onClean={() => onSelect && onSelect(null)}
                    onChange={onChange as any}
                    onClickSearch={handleClickSearch}
                    readOnly={readOnly}
                />
            )}

            <SttSelectMshipDialog
                open={dialogOpened}
                onClose={() => setDialogOpened(false)}
                onSelectMship={(mship: any) => {
                    setDialogOpened(false);
                    onSelect?.(mship);
                }}
            />
        </>
    );
    return grid ? <Grid size={{ xs, md }}>{content}</Grid> : <>{content}</>;
}
